
    import "src/app/AppSeller/SettingsPage/PickupAddress/index.module.scss?farm_css_modules";
    
    export default {"pickupAddressPage": `pickupAddressPage-db0036f2`,"pickupAddressesList": `pickupAddressesList-db0036f2`,"title": `title-db0036f2`}
    